import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import {
  WebAppSecurityApp,
  WebAppSecurityProtection,
  WebAppSecurityClient,
  WebSecurityInfrastructure,
} from "../../../app-constants";

function Websecurityefficient() {
  return (
    <section className="websecurity_efficient p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Ensuring Credibility with <span>Efficient Web Security</span>{" "}
              Practices
            </h2>
            <p>
              Security has never been an add-on at our company – it is an
              intrinsic component of the functionality of any web application we
              create. Thus, the overall security can be described as
              multilayered, encompassing various levels, including code and
              infrastructure. As cybersecurity threats evolve, we apply the best
              practices and latest tools to protect your data and users’ trust.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              //   autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">{WebAppSecurityApp}</div>
                  <div className="web-security_content">
                    <h5>Application Security</h5>
                    <ul>
                      <li>Rigorous automated testing</li>
                      <li>Proactive threat modeling</li>
                      <li>Advanced attack-blocking mechanism</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {WebAppSecurityProtection}
                  </div>
                  <div className="web-security_content">
                    <h5>Data Protection</h5>
                    <ul>
                      <li>Strict regulatory compliance</li>
                      <li>End-to-end data encryption</li>
                      <li>Adherence to industry-leading security standards</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {WebAppSecurityClient}
                  </div>
                  <div className="web-security_content">
                    <h5>Client Assurance</h5>
                    <ul>
                      <li>Personalized security strategies</li>
                      <li>Ironclad NDAs and SLAs</li>
                      <li>Clear intellectual property policies</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {WebSecurityInfrastructure}
                  </div>
                  <div className="web-security_content">
                    <h5>Infrastructure Security</h5>
                    <ul>
                      <li>Regular security audits</li>
                      <li>Secure cloud deployment</li>
                      <li>Continuous monitoring and threat detection</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">{WebAppSecurityApp}</div>
                  <div className="web-security_content">
                    <h5>Application Security</h5>
                    <ul>
                      <li>Rigorous automated testing</li>
                      <li>Proactive threat modeling</li>
                      <li>Advanced attack-blocking mechanism</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {WebAppSecurityProtection}
                  </div>
                  <div className="web-security_content">
                    <h5>Data Protection</h5>
                    <ul>
                      <li>Strict regulatory compliance</li>
                      <li>End-to-end data encryption</li>
                      <li>Adherence to industry-leading security standards</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {WebAppSecurityClient}
                  </div>
                  <div className="web-security_content">
                    <h5>Client Assurance</h5>
                    <ul>
                      <li>Personalized security strategies</li>
                      <li>Ironclad NDAs and SLAs</li>
                      <li>Clear intellectual property policies</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web-security-box">
                  <div className="web-security-icon">
                    {WebSecurityInfrastructure}
                  </div>
                  <div className="web-security_content">
                    <h5>Infrastructure Security</h5>
                    <ul>
                      <li>Regular security audits</li>
                      <li>Secure cloud deployment</li>
                      <li>Continuous monitoring and threat detection</li>
                    </ul>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Websecurityefficient;
